import request from '@/util/request';

export const getList = (current, size, params) => {
  return request({
    url: '/api/dingwx/syncoperatelog/page',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    },
  });
};

export const getDetail = (id) => {
  return request({
    url: '/api/dingwx/syncoperatelog/detail',
    method: 'get',
    params: {
      id,
    },
  });
};

export const remove = (ids) => {
  return request({
    url: '/api/dingwx/syncoperatelog/remove',
    method: 'post',
    params: {
      ids,
    },
  });
};

export const reSync = (ids) => {
  return request({
    url: '/api/dingwx/syncoperatelog/reSync',
    method: 'post',
    params: {
      ids,
    },
  });
};

export const add = (row) => {
  return request({
    url: '/api/dingwx/syncoperatelog/submit',
    method: 'post',
    data: row,
  });
};

export const update = (row) => {
  return request({
    url: '/api/dingwx/syncoperatelog/submit',
    method: 'post',
    data: row,
  });
};

export const initialSync = () => {
  return request({
    url: '/api/dingwx/syncoperatelog/initialSync',
    method: 'get',
    params: {},
  });
};
export const syncOperate = () => {
  return request({
    url: '/api/dingwx/syncoperatelog/syncOperate',
    method: 'get',
    params: {},
  });
};
